function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.2593 0.726562C15.0334 0.726562 0.259277 15.053 0.259277 32.7266C0.259277 50.4002 15.0334 64.7266 33.2593 64.7266C51.4852 64.7266 66.2593 50.4002 66.2593 32.7266C66.2593 15.053 51.4852 0.726562 33.2593 0.726562ZM33.2593 58.3266L39.8593 51.9266L43.1593 48.7266V42.3266H36.5593V39.1266L33.2593 35.9266H23.3593V45.5266L29.9593 51.9266V58.1026C16.9573 56.5218 6.85928 45.757 6.85928 32.7266L10.1593 35.9266H16.7593V29.5266H23.3593L33.2593 19.9266V13.5266H26.6593L23.3593 10.3266V9.01456C29.7046 6.49993 36.814 6.49993 43.1593 9.01456V13.5266L39.8593 16.7266V23.1266L43.1593 26.3266L53.4883 16.3106C56.001 19.2255 57.8115 22.6473 58.7881 26.3266H53.0593L46.4593 32.7266V39.1266L49.7593 42.3266H56.3593L57.3031 43.2418C53.1583 52.1186 43.9513 58.3266 33.2593 58.3266Z",
  fill: "white"
});

var SvgWorld = function SvgWorld(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 65,
    viewBox: "0 0 67 65",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWorld, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/world.6a98fd90.svg";
export { ForwardRef as ReactComponent };